export const legalNoticeContent = `# AVISO LEGAL

## PricingIntelligence

---

> **AVISO IMPORTANTE:** Este documento es un modelo referencial y requiere revision obligatoria por un abogado habilitado en el Estado Plurinacional de Bolivia antes de su publicación o uso. No constituye asesoramiento juridico. Los placeholders indicados entre corchetes [ASI] deben ser completados con la información correspondiente antes de su publicación.

---

## 1. DATOS DEL TITULAR

De conformidad con la normativa comercial boliviana, se comunican los siguientes datos identificativos del titular del presente sitio web:

| Dato | Detalle |
|---|---|
| **Razon Social** | [NOMBRE DE LA EMPRESA] |
| **Tipo de Sociedad** | [TIPO_SOCIEDAD] |
| **NIT** | [NIT] |
| **Matricula SEPREC** | [MATRICULA_SEPREC] |
| **Domicilio Legal** | [DIRECCION], [CIUDAD], Estado Plurinacional de Bolivia |
| **Telefono** | [TELEFONO] |
| **Correo Electronico** | [EMAIL_CONTACTO] |
| **Sitio Web** | [URL_SITIO_WEB] |
| **Representante Legal** | [NOMBRE_REPRESENTANTE] |
| **Actividad Principal** | Desarrollo y comercializacion de software de inteligencia de precios en modalidad SaaS |

---

## 2. OBJETO DEL SITIO WEB

**2.1.** El presente sitio web tiene por objeto:

   a) Proporcionar informacion sobre la plataforma PricingIntelligence, sus funcionalidades, planes y precios;

   b) Permitir el acceso de usuarios registrados a la plataforma SaaS de PricingIntelligence;

   c) Ofrecer recursos informativos relacionados con la gestion de precios e inteligencia comercial;

   d) Facilitar la comunicacion entre [NOMBRE DE LA EMPRESA] y sus clientes, prospectos y el publico en general;

   e) Gestionar el proceso de registro de nuevos usuarios y contratacion del Servicio.

**2.2.** La informacion publicada en el sitio web tiene caracter general e informativo y no constituye, en ningun caso, asesoria profesional, legal, tributaria, financiera ni comercial.

---

## 3. PROPIEDAD INTELECTUAL

**3.1.** Todos los contenidos del sitio web, incluyendo textos, imagenes, graficos, logotipos, iconos, fotografias, diseno grafico, codigo fuente, software, bases de datos, marcas, nombres comerciales y cualquier otro signo distintivo, son propiedad de [NOMBRE DE LA EMPRESA] o de sus respectivos titulares, y se encuentran protegidos por la legislacion de propiedad intelectual e industrial del Estado Plurinacional de Bolivia.

**3.2.** Queda prohibida la reproduccion, distribucion, comunicacion publica, transformacion o cualquier otra forma de explotacion de los contenidos del sitio web sin autorizacion previa y expresa por escrito.

**3.3.** El acceso al sitio web no otorga al usuario ningun derecho de propiedad intelectual o industrial sobre sus contenidos.

---

## 4. RESPONSABILIDAD SOBRE CONTENIDOS

**4.1.** [NOMBRE DE LA EMPRESA] realiza esfuerzos razonables para que la informacion publicada sea precisa y actualizada. No obstante, no garantiza la exactitud, completitud, vigencia ni idoneidad de dicha informacion.

**4.2.** [NOMBRE DE LA EMPRESA] no sera responsable por:

   a) Errores u omisiones en la informacion publicada;
   b) Danos derivados del acceso, uso o imposibilidad de uso del sitio web;
   c) Danos causados por virus informaticos o elementos daninos;
   d) Decisiones tomadas basandose en la informacion publicada;
   e) Interrupciones en el funcionamiento del sitio web.

**4.3.** La informacion sobre precios, planes y funcionalidades es orientativa y puede estar sujeta a cambios.

---

## 5. ENLACES A TERCEROS

**5.1.** El sitio web podra contener enlaces a sitios web de terceros, proporcionados unicamente para conveniencia e informacion del usuario.

**5.2.** [NOMBRE DE LA EMPRESA] no controla, patrocina ni respalda los contenidos de los sitios web de terceros enlazados.

**5.3.** La inclusion de un enlace no implica relacion comercial, asociacion, patrocinio ni aprobacion.

---

## 6. PROTECCION DE DATOS PERSONALES

**6.1.** El tratamiento de datos personales realizado a traves del sitio web se rige por la Politica de Privacidad de PricingIntelligence.

**6.2.** El sitio web utiliza unicamente cookies esenciales necesarias para su funcionamiento.

**6.3.** Los datos proporcionados a traves de formularios seran tratados conforme a la Politica de Privacidad.

**6.4.** El usuario podra ejercer sus derechos de acceso, rectificacion, eliminacion, portabilidad y oposicion conforme a lo establecido en la Politica de Privacidad.

---

## 7. CONDICIONES DE ACCESO Y USO

**7.1.** El acceso al sitio web es gratuito, salvo el costo de la conexion a internet.

**7.2.** El usuario se compromete a utilizar el sitio web de conformidad con la legislacion vigente, el presente Aviso Legal, las buenas costumbres y el orden publico.

**7.3.** Queda prohibido el uso del sitio web para fines ilicitos o daninos.

**7.4.** [NOMBRE DE LA EMPRESA] se reserva el derecho de restringir el acceso a usuarios que incumplan las presentes condiciones.

---

## 8. MODIFICACIONES

**8.1.** [NOMBRE DE LA EMPRESA] se reserva el derecho de modificar el presente Aviso Legal en cualquier momento. Las modificaciones entraran en vigencia desde su publicacion en el sitio web.

**8.2.** Se recomienda al usuario revisar periodicamente el presente Aviso Legal.

---

## 9. LEGISLACION APLICABLE Y JURISDICCION

**9.1.** El presente Aviso Legal se rige por las leyes del Estado Plurinacional de Bolivia.

**9.2.** Para la resolucion de cualquier controversia, las partes se someten a la jurisdiccion de los Tribunales competentes de la ciudad de [CIUDAD], Estado Plurinacional de Bolivia.

---

## 10. CONTACTO

Para cualquier consulta relacionada con el presente Aviso Legal, puede contactarnos a traves de:

- **Correo electronico:** [EMAIL_CONTACTO]
- **Direccion postal:** [NOMBRE DE LA EMPRESA], [DIRECCION], [CIUDAD], Estado Plurinacional de Bolivia
- **Telefono:** [TELEFONO]

---

**PricingIntelligence**
*Version: 1.0*
`;
